module.exports = __webpack_public_path__ + "img/tree_circle_gray.6225e9a8.svg";